import React, {PropTypes} from "react";
import {connect} from "react-redux";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import ToolTip from "react-bootstrap/lib/Tooltip";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Modal from "react-bootstrap/lib/Modal";
import * as actions from "../../../redux/actions/leaveActions";

class LeaveHistory extends React.Component {

  constructor() {
    super();
    this.state = {showDialog: false, row: null}
    this.checkCross = this.checkCross.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    this.setState({showDialog: false})
  }

  componentDidMount() {
    this.props.changeBanner("Leave History");
    this.props.dispatch(actions.getLeaveHistory());
  }

  returnNull() {
    return null;
  }

  checkNull(cell, row, formatExtraData, rowIdx) {

    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }

  checkNoOfDays(cell, row, formatExtraData, rowIdx) {

      if(row.noOfDays == 0) {
        return row.paycut;
      } else {
        return row.noOfDays;
      }
  }

  check(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell.substr(0, 10);

  }

  checkDate(cell, row, formatExtraData, rowIdx) {

    let cell1 = new Date(cell);
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }

    else return cell1.toString().substr(0, 16);
  }

  checkCross(cell, row, formatExtraData, rowIdx) {
    if (row.leaveStatus == 'applied' || (row.leaveStatus == 'approved' && (new Date(row.startDate) > new Date())))
      return <a  >
        <OverlayTrigger placement="top" overlay={<ToolTip id="tooltip">Cancel</ToolTip>}>


          <img onClick={()=> {
            this.setState({showDialog: true, row: row});
            //this.props.dispatch(actions.rejectLeave({applicantId: row.applicantId,leaveRemark: null,leaveProcess: 'cancel'}));
          }
          }
               className="hand" style={{cursor: 'hand'}} src="/public/images/error.png"/>
        </OverlayTrigger>
      </a>;
    else
      return <a>
        <OverlayTrigger placement="top" overlay={<ToolTip id="tooltip">Disabled</ToolTip>}>


          <img onClick={()=> {
            // this.setState({showDialog: true,row: row});
            //this.props.dispatch(actions.rejectLeave({applicantId: row.applicantId,leaveRemark: null,leaveProcess: 'cancel'}));
          }
          }
               className="hand" style={{cursor: 'hand'}} src="/public/images/error2.png"/>
        </OverlayTrigger>
      </a>;
  }

  render() {

    return (
      <div>
        <div className="inner-col-wrap inner-table-wrap ">
          <h2 style={{marginTop: '5'}}>Leave Application Details</h2>
          <div style={{
            paddingBottom: '40px',
            borderLeftStyle: 'solid',
            borderLeftColor: 'rgb(92, 184, 92)',
            borderWidth: '1px',
            borderBottomColor: '#008bcf',
          }}>
            <BootstrapTable
              exportCSV={true}
              height="500"
              search={true}
              data={this.props.history.history} striped={false} hover={true} condensed={true}>
              <TableHead dataSort={true}
                         hidden={true}
                         dataFormat={this.returnNull}
                         isKey={true} dataField="applicantId"></TableHead>
              <TableHead

                columnClassName="rowY"
                width={35}
                dataFormat={this.checkCross}
                dataField="empId"><label style={{fontSize: '10'}}></label></TableHead>

              <TableHead dataSort={true}
                         width={100}
                         dataFormat={this.checkDate}
                         isKey={false} dataField="startDate">Start <br/> Date</TableHead>
              <TableHead dataSort={true}
                         width={100}
                         dataField="endDate" dataFormat={this.checkDate}>End <br/>Date</TableHead>

              <TableHead dataSort={true}
                         dataFormat={this.check}
                         width={100}
                         dataField="appliedOn">Applied<br/>On</TableHead>
              <TableHead dataSort={true}
                         width={100}
                         dataField="approvedOn" dataFormat={this.check}>Approved <br/>On</TableHead>

              <TableHead dataSort={true}
                         width={80}
                         dataFormat={this.checkNull}

                         dataField="leaveType">Leave <br/>Type</TableHead>

              <TableHead dataField="leaveStatus"
                         width={100}
                         dataFormat={this.checkNull}
                         dataSort={true}
              >Leave <br/> Status</TableHead>
              <TableHead dataSort={true}
                         width={80}
                         dataFormat={this.checkNoOfDays}
                         dataField="noOfDays">No of <br/>Days</TableHead>
              <TableHead dataSort={true}
                         dataField="leaveReason" dataFormat={this.checkNull}>Leave<br/> Reason</TableHead>
              <TableHead dataSort={true}
                         dataFormat={this.checkNull}
                         dataField="leaveRemark">Remark</TableHead>
            </BootstrapTable>
          </div>
        </div>
        <Modal show={this.state.showDialog} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Cancel Leave</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Your Leave Application</h4>
            {this.state.row != null ?
              <div>
                <p>Leave Type: {this.state.row.leaveType}</p>
                <p>Start Date: {this.state.row.startDate}</p>
                <p>End Date: {this.state.row.endDate}</p>
                <p>No of Days: {this.state.row.noOfDays}</p>
                <p>Leave
                  Reason: {this.state.row.leaveReason != null && this.state.row.leaveReason != "" ? this.state.row.leaveReason : 'NA'}</p>
              </div>
              : null}
            <hr />
            <button onClick={()=> {
              this.setState({showDialog: false});
              this.props.dispatch(actions.cancelLeave({
                applicantId: this.state.row.applicantId,
                leaveRemark: null,
                leaveProcess: 'cancel'
              }));
            }} className="btn btn-default">Cancel Leave
            </button>

          </Modal.Body>
        </Modal>

      </div>
    );
  }

}

LeaveHistory.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    history: state.leave[2]
  };

}

export default connect(mapStateToProps)(LeaveHistory);




/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveHistory/LeaveHistory.js
 **/